import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { IClsMenuItem } from 'ngx-register-base';
import { environment } from '../../../../environments/environment';
import { QueryOptions } from '@apollo/client/core';
import { QUERY_MAIN_MENU } from './page-menu.gql';
import { Apollo } from 'apollo-angular';

@Injectable({ providedIn: 'root' })
export class PageMenuStore {
  public mainMenu$ = new BehaviorSubject<IClsMenuItem[]>([]);
  protected apollo = inject(Apollo);

  readonly fetchMenu = (): Observable<{ readonly data?: { usr_v_main_menu: any } }> => {
    const productionExcludedItems: string[] = [];
    const isProd = environment.production;

    const options: QueryOptions = {
      query: QUERY_MAIN_MENU,
      fetchPolicy: 'no-cache',
      variables: {
        where: {
          code: {
            _nin: isProd ? productionExcludedItems : [],
          },
        },
      },
    };

    return this.apollo
      .query<{ usr_v_main_menu: IClsMenuItem[] }>(options)
      .pipe(tap(({ data: { usr_v_main_menu: menu } }) => this.mainMenu$.next(menu)));
  };
}
